import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalenderSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calender-sparkle, date, plan"} maskId="square-filled-radius-0-stroke-1-IconCalenderSparkle"><path d="M8 2H7V4H3V21H13V20H4V9H20V13H21V4H17V2H16V4H8V2Z" fill="currentColor"/><path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalenderSparkle;
